import type { SchemaViewerFormProviderProps } from "./schema-viewer-form.type";
import type { PropsWithChildren } from "react";

import { SchemaViewerFormContext } from "./schema-viewer-form.context";

export const SchemaViewerFormProvider = ({
  children,
  ...props
}: PropsWithChildren<SchemaViewerFormProviderProps>) => {
  return (
    <SchemaViewerFormContext.Provider value={props}>
      {children}
    </SchemaViewerFormContext.Provider>
  );
};
